import { poll } from './poll.js';

export const RENTAL_COLLECTION_POLL_MAX_ATTEMPTS = 6;

const DEFAULT_RETRY_AFTER_MS = 2000;
const MIN_RETRY_AFTER_MS = 250;
const MAX_RETRY_AFTER_MS = 5000;

export function isRentalCollectionAvailabilityPending(payload) {
    return payload?.availability?.state === 'pending';
}

export function rentalCollectionRetryAfterMs(payload) {
    const retryAfterMs = Number(payload?.availability?.retryAfterMs);
    if (!Number.isFinite(retryAfterMs)) return DEFAULT_RETRY_AFTER_MS;

    return Math.max(
        MIN_RETRY_AFTER_MS,
        Math.min(MAX_RETRY_AFTER_MS, Math.round(retryAfterMs))
    );
}

/**
 * Adapts the Rental Collection pending contract to the generic polling loop.
 * The caller still owns request construction, UI state, and cancellation.
 */
export async function pollRentalCollectionAvailability({
    request,
    signal,
    onPending = () => {},
    maxAttempts = RENTAL_COLLECTION_POLL_MAX_ATTEMPTS,
    wait
}) {
    const outcome = await poll({
        request,
        shouldRetry: isRentalCollectionAvailabilityPending,
        retryDelayMs: rentalCollectionRetryAfterMs,
        signal,
        onRetry: onPending,
        maxAttempts,
        ...(wait ? { wait } : {})
    });

    return {
        state: outcome.state === 'complete' ? 'ready' : 'exhausted',
        payload: outcome.value,
        attempts: outcome.attempts
    };
}
